const rules = [
    {
        "url": "*",
        "network": "Skimlinks"
    },
    {
        "url": "https://www.adidas.co.uk",
        "network": "Awin"
    },
    {
        "url": "https://www.adidas.com",
        "network": "Digidip"
    },
      {
        "url": "https://www.adidas.fr",
        "network": "Skimlinks"
    },
       {
        "url": "https://www.adidas.de",
        "network": "Awin"
    },
    {
        "url": "https://www.athleticpropulsionlabs.com",
        "network": "Rakuten"
    },
        {
        "url": "https://antonioli.eu",
        "network": "CJ Affiliates"
    },
         {
        "url": "https://axelarigato.com",
        "network": "CJ Affiliates"
    },
      {
        "url": "https://www.bergdorfgoodman.com",
        "network": "Digidip"
    },
     {
        "url": "https://www.bstn.com/us_en",
        "network": "CJ Affiliates"
    },
      {
        "url": "https://www.brooksrunning.com/en_us",
        "network": "Impact"
    },
       {
        "url": "https://emea.mizuno.com",
        "network": "Impact"
    },
    {
        "url": "https://www.chloe.com",
        "network": "Rakuten"
    },
    {
        "url": "https://www.converse.com/uk",
        "network": "Awin"
    },
 
        {
        "url": "https://www.danielloboutique.it",
        "network": "CJ Affiliates"
    },
   {
        "url": "https://uk.diesel.com/",
        "network": "Rakuten"
    },
   {
        "url": "https://it.diesel.com",
        "network": "Rakuten"
    },
   {
        "url": "https://www.thedoublef.com",
        "network": "CJ Affiliates"
    },
    {
        "url": "https://www.endclothing.com",
        "network": "Impact"
    },
    {
        "url": "https://launches.endclothing.com",
        "network": "Impact"
    },
    {
        "url": "https://www.farfetch.com",
        "network": "Partnerize"
    },
    {
        "url": "https://www.merrell.com/uk",
        "network": "Partnerize"
    },
     {
        "url": "https://www.merrell.com/UK",
        "network": "Partnerize"
    },
     {
        "url": "https://www.merrell.com/fr",
        "network": "Partnerize"
    },
      {
        "url": "https://www.merrell.com/FR",
        "network": "Partnerize"
    },

     {
        "url": "https://www.merrell.com/de",
        "network": "Partnerize"
    },
      {
        "url": "https://www.merrell.com/DE",
        "network": "Partnerize"
    },
    {
        "url": "https://www.merrell.com/us",
        "network": "Skimlinks"
    },
      {
        "url": "https://www.merrell.com/US",
        "network": "Skimlinks"
    },
       {
        "url": "https://www.saucony.com/de",
        "network": "Partnerize"
    },
       {
        "url": "https://www.saucony.com/DE",
        "network": "Partnerize"
    },
      {
        "url": "https://www.saucony.com/fr",
        "network": "Partnerize"
    },
       {
        "url": "https://www.saucony.com/FR",
        "network": "Partnerize"
    },
       {
        "url": "https://www.saucony.com/it",
        "network": "Partnerize"
    },
       {
        "url": "https://www.saucony.com/IT",
        "network": "Partnerize"
    },
      {
        "url": "https://www.saucony.com/uk",
        "network": "Partnerize"
    },
      {
        "url": "https://www.saucony.com/UK",
        "network": "Partnerize"
    },
      {
        "url": "https://www.saucony.com/NL",
        "network": "Skimlinks"
    },
    {
        "url": "https://www.saucony.com/nl",
        "network": "Skimlinks"
    },
    {
        "url": "https://www.ferragamo.com",
        "network": "Partnerize"
    },
    {
        "url": "https://www.footshop.eu",
        "network": "CJ Affiliates"
    },
    {
        "url": "https://www.ftshp.co.uk",
        "network": "CJ Affiliates"
      },
      {
        "url": "https://www.footshop.com",
        "network": "CJ Affiliates"
      },
     {
        "url": "https://www.fwrd.com",
        "network": "CJ Affiliates"
    },
    {
        "url": "https://www.gucci.com",
        "network": "Rakuten"
    },
      {
        "url": "https://www.goat.com",
        "network": "Impact"
    },
     {
        "url": "https://hbx.com",
        "network": "CJ Affiliates"
    },
    {
        "url": "https://www.hoka.com/en/us",
        "network": "Rakuten"
    },
     {
        "url": "https://www.hoka.com/en/gb",
        "network": "Awin"
    },
  {
        "url": "https://www.hoka.com/fr/",
        "network": "Skimlinks"
    },
    {
        "url": "https://www.hoka.com/it/",
        "network": "Skimlinks"
    },
   {
        "url": "https://www.hoka.com/de/",
        "network": "Skimlinks"
    },
  {
        "url": "https://www.hoka.com/nl/",
        "network": "Skimlinks"
    },
      {
        "url": "https://www.jwanderson.com",
        "network": "Rakuten"
    },

 
       {
        "url": "https://www.luisaviaroma.com",
        "network": "CJ Affiliates"
    },
  {
        "url": "https://www.alexandermcqueen.com",
        "network": "Rakuten"
    },


    {
        "url": "https://www.loewe.com",
        "network": "Rakuten"
    },

  

      {
        "url": "https://www.mytheresa.com",
        "network": "Rakuten"
    },
    {
        "url": "https://nakedcph.com",
        "network": "CJ Affiliates"
    },
    {
        "url": "https://www.newbalance.com",
        "network": "Skimlinks"
    },
    {
        "url": "https://www.nike.com/fr",
        "network": "Skimlinks"
    },
   {
        "url": "https://www.nike.com/it",
        "network": "Skimlinks"
    },
    {
        "url": "https://www.nike.com/t",
        "network": "CJ Affiliates"
    },
   {
        "url": "https://www.nike.com/w",
        "network": "CJ Affiliates"
    },
        {
        "url": "https://normanwalsh.com",
        "network": "Impact"
    },
      {
        "url": "https://uk.puma.com",
        "network": "CJ Affiliates"
    },
    {
        "url": "https://www.ssense.com",
        "network": "Rakuten"
    },
 
  
    {
        "url": "https://stockx.com",
        "network": "Impact"
    },
       {
        "url": "https://www.tessabit.com",
        "network": "Rakuten"
    },
       {
        "url": "https://tres-bien.com",
        "network": "CJ Affiliates"
    },
         {
        "url": "https://www.thenorthface.co.uk",
        "network": "CJ Affiliates"
    },
      {
        "url": "https://us.isabelmarant.com",
        "network": "Rakuten"
    },
    {
        "url": "https://intl.isabelmarant.com",
        "network": "Rakuten"
    },
      {
        "url": "https://isabelmarant.com",
        "network": "Rakuten"
    },
    {
        "url": "https://walesbonner.com",
        "network": "Rakuten"
    },
    {
        "url": "https://www.valentino.com",
        "network": "Rakuten"
    }, 
    {
      "url": "https://havenshop.com",
      "network": "Kutoku"
    },
    {
      "url": "https://crownnorthampton.com",
      "network": "Kutoku"
    },
     {
        "url": "https://www.asics.com/gb",
        "network": "Partnerize"
    },
  {
        "url": "https://www.salomon.com/en-us",
        "network": "Impact"
    },
      {
        "url": "https://www.nike.com/gb",
        "network": "Awin"
    }
];

window.rules = rules;
